import { list } from 'src/modules/eLabel/eLabelService';
import selectors from 'src/modules/eLabel/list/eLabelListSelectors';
import { i18n } from 'src/i18n';
import exporterFields from 'src/modules/eLabel/list/eLabelListExporterFields';
import Errors from 'src/modules/shared/error/errors';
import Exporter from 'src/modules/shared/exporter/exporter';

const prefix = 'ELABEL_LIST';

const eLabelListActions = {
  FETCH_STARTED: `${prefix}_FETCH_STARTED`,
  FETCH_SUCCESS: `${prefix}_FETCH_SUCCESS`,
  FETCH_ERROR: `${prefix}_FETCH_ERROR`,
  TOGGLE_LOADING: `${prefix}_TOGGLE_LOADING`,

  RESETED: `${prefix}_RESETED`,
  SELECTEDS_CHANGED: `${prefix}_SELECTEDS_CHANGED`,

  PAGINATION_CHANGED: `${prefix}_PAGINATION_CHANGED`,
  SORTER_CHANGED: `${prefix}_SORTER_CHANGED`,

  EXPORT_STARTED: `${prefix}_EXPORT_STARTED`,
  EXPORT_SUCCESS: `${prefix}_EXPORT_SUCCESS`,
  EXPORT_ERROR: `${prefix}_EXPORT_ERROR`,

  doExport: () => async (dispatch, getState) => {
    try {
      if (!exporterFields || !exporterFields.length) {
        throw new Error('exporterFields is required');
      }

      dispatch({
        type: eLabelListActions.EXPORT_STARTED,
      });

      const filter = selectors.selectFilter(getState());
      const response = await list({
        filter,
        orderBy: selectors.selectOrderBy(getState()),
      });

      new Exporter(
        exporterFields,
        i18n('entities.eLabel.exporterFileName'),
      ).transformAndExportAsExcelFile(response.rows);

      dispatch({
        type: eLabelListActions.EXPORT_SUCCESS,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: eLabelListActions.EXPORT_ERROR,
      });
    }
  },
};

export default eLabelListActions;
